import React, { useState } from 'react';
import { Shop, setDefaultShop } from '../../modules/editor';
import { ReactSVG } from 'react-svg';
import { getPathAfterBuild } from '../../util/file';
import { useDispatch } from 'react-redux';


interface Props {
  shops: Shop[];
  selectedShop: Shop;
  setSelectedShop: (arg0: Shop) => void;
}

function ShopsDropdown ({ shops, selectedShop, setSelectedShop }: Props) {
  const dispatch = useDispatch();

  const hasOnlyBaseShop = shops.length === 1;
  const [open, setOpen] = useState(false);
  
  const toggleOpen = () => setOpen(!open);

  const onSelect = (item: Shop) => {
    setSelectedShop(item);
    dispatch(setDefaultShop(item));
    toggleOpen();
  };

  const iconImage = (path) => {
		const context = require.context('../../assets/images/', true);
		return getPathAfterBuild(context, path);
	};

  return (
    <div className={hasOnlyBaseShop ? 'select-shops inactive' : 'select-shops'}>
      <div className={open ? 'select-shops-header open' : 'select-shops-header'} onClick={toggleOpen}>
        <strong>{selectedShop?.shopName?? "쇼핑몰을 선택하세요"}</strong>
        <ReactSVG className="caret" src={iconImage(`./icon/toolbar/arrow_down.svg`)} width="10" />
        {open && (
          <div className='select-shops-body'>
            <ul>
              {
                shops.map((item: Shop, idx: number) => (
                  <li key={idx} className={item?.shopId === selectedShop?.shopId ? 'active' : ''}>
                    <button type='button' onClick={() => onSelect(item)}>
                      {item.shopName}
                    </button>
                  </li>
                ))
              }
            </ul>
          </div>
        )}
      </div>
    </div>
  )
}

export default ShopsDropdown;
